import React from 'react';
export function Footer() {
  return <footer className="w-full bg-black border-t border-[#39FF14]/20 py-10 px-4" data-id="element-207">
      <div className="max-w-3xl mx-auto text-center" data-id="element-208">
        <div className="text-[#39FF14] text-2xl font-black tracking-widest mb-4" data-id="element-209">
          🇧🇷 PROFEPACK™
        </div>
        <p className="text-gray-400 text-sm leading-relaxed mb-4 max-w-xl mx-auto" data-id="element-210">
          El sistema de cátedra N°1 para docentes de Português de primaria y
          secundaria en Argentina.
        </p>
        <p className="text-gray-400 text-sm italic mb-6" data-id="element-211">
          Porque enseñar Português no debería costarte todos los domingos del
          año.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 text-sm text-gray-300 mb-6" data-id="element-212">
          <span data-id="element-213">📧 soporteprofepack@gmail.com</span>
          <span className="hidden sm:inline" data-id="element-214">•</span>
          <span data-id="element-215">📲 @profepack</span>
          <span className="hidden sm:inline" data-id="element-216">•</span>
          <span data-id="element-217">🌐 www.profepack.com</span>
        </div>

        <div className="h-px bg-[#39FF14]/20 mb-6" data-id="element-218" />
        <p className="text-gray-400 text-xs mb-2" data-id="element-219">
          © ProfePack™ 2025 — Todos los derechos reservados.
        </p>
        <p className="text-gray-500 text-xs mb-6" data-id="element-220">
          Prohibida la reproducción y redistribución sin autorización expresa.
        </p>
        <p className="text-gray-500 text-xs font-bold tracking-widest" data-id="element-221">
          🇧🇷 "O próximo domingo pode ser diferente."
        </p>
      </div>
    </footer>;
}